import { render } from "./BFaceStopSubscriptionButton.vue?vue&type=template&id=d10e4198"
import script from "./BFaceStopSubscriptionButton.vue?vue&type=script&lang=js"
export * from "./BFaceStopSubscriptionButton.vue?vue&type=script&lang=js"
script.render = render

export default script